import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export type FormSubmission = {
  surveyId: number;
  answers: Array<{
    questionId: number;
    answer: string;
    shouldReverseScore: boolean;
  }>;
};

export const submitForm = ({
  surveyId,
  answers,
}: FormSubmission): Promise<void> => {
  return axios.post("/api/surveys/submit", { surveyId, answers });
};

export const useFormSubmissionMutation = () => {
  return useMutation({
    mutationFn: ({ surveyId, answers }: FormSubmission) =>
      submitForm({
        surveyId,
        answers,
      }),
  });
};
